import {
  PAID_USERS_REPORT_REQUEST,
  PAID_USERS_REPORT_SUCCESS,
  PAID_USERS_REPORT_FAIL,
  PAID_USERS_LIST_REQUEST,
  PAID_USERS_LIST_SUCCESS,
  PAID_USERS_LIST_FAIL,
  CLEAR_REPORT_ERRORS,
  REVENUE_REPORT_REQUEST,
  REVENUE_REPORT_SUCCESS,
  REVENUE_REPORT_FAIL,
  CONVERSION_REPORT_REQUEST,
  CONVERSION_REPORT_SUCCESS,
  CONVERSION_REPORT_FAIL,
  RETENTION_REPORT_REQUEST,
  RETENTION_REPORT_SUCCESS,
  RETENTION_REPORT_FAIL,
} from "../constants/adminReportConstants";

const initialState = {
  report: null,
  revenueReport: null,
  conversionReport: null,
  retentionReport: null,
  paidUsersList: [],
  loading: false,
  listLoading: false,
  error: null,
  pagination: null,
};

export const adminReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case PAID_USERS_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case PAID_USERS_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        report: action.payload,
        error: null,
      };
    case PAID_USERS_REPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case REVENUE_REPORT_REQUEST:
      return { ...state, loading: true, error: null };
    case REVENUE_REPORT_SUCCESS:
      return { ...state, loading: false, revenueReport: action.payload, error: null };
    case REVENUE_REPORT_FAIL:
      return { ...state, loading: false, error: action.payload };

    case CONVERSION_REPORT_REQUEST:
      return { ...state, loading: true, error: null };
    case CONVERSION_REPORT_SUCCESS:
      return { ...state, loading: false, conversionReport: action.payload, error: null };
    case CONVERSION_REPORT_FAIL:
      return { ...state, loading: false, error: action.payload };

    case RETENTION_REPORT_REQUEST:
      return { ...state, loading: true, error: null };
    case RETENTION_REPORT_SUCCESS:
      return { ...state, loading: false, retentionReport: action.payload, error: null };
    case RETENTION_REPORT_FAIL:
      return { ...state, loading: false, error: action.payload };

    case PAID_USERS_LIST_REQUEST:
      return {
        ...state,
        listLoading: true,
        error: null,
      };
    case PAID_USERS_LIST_SUCCESS:
      return {
        ...state,
        listLoading: false,
        paidUsersList: action.payload.data,
        pagination: action.payload.pagination,
        error: null,
      };
    case PAID_USERS_LIST_FAIL:
      return {
        ...state,
        listLoading: false,
        error: action.payload,
      };

    case CLEAR_REPORT_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
